// import React, { useEffect, useRef, useState } from "react";
// import { Tabs, Tab, Button } from "@mui/material";
// import { DataGrid, gridClasses } from "@mui/x-data-grid";
// import { HttpService } from "../../../service/HttpService";
// import dayjs from "dayjs";
// import { TbFilterEdit } from "react-icons/tb";
// import DateTimeModal from "../../Schedule/ScheduleListAdd/DateTimeModal";

// function Rockwool() {
//   const httpService = new HttpService();
//   const [tab, setTab] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [rows, setRows] = useState([]);
//   const [rowCount, setRowCount] = useState(0);
//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(15);
//   const [openDateModal, setOpenDateModal] = useState(false);
//   const dateFilterData = JSON.parse(localStorage.getItem("rockwoolDateFilter"));
//   const [startDate, setStartDate] = useState(
//     dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
//   );
//   const [endDate, setEndDate] = useState(
//     dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
//   );
//   const [selectedRadio, setSelectedRadio] = useState(
//     dateFilterData?.selectedRadio || "month"
//   );

//   useEffect(() => {
//     let isActive = true;
//     (async () => {
//       setLoading(true);
//       try {
//         const url =
//           `rockwool/rockwool-history` +
//           `?page=${page + 1}&pageSize=${pageSize}` +
//           `&start_date=${startDate}&end_date=${endDate}` +
//           `&search=${search}`;
//         const res = await httpService.get(url);
//         const list = Array.isArray(res?.data?.data)
//           ? res.data.data
//           : Array.isArray(res?.data)
//           ? res.data
//           : [];
//         const total = res?.data?.pagination?.total || list.length || 0;
//         if (isActive) {
//           setRows(list);
//           setRowCount(total);
//         }
//       } catch (_) {
//         if (isActive) {
//           setRows([]);
//           setRowCount(0);
//         }
//       } finally {
//         if (isActive) setLoading(false);
//       }
//     })();
//     return () => {
//       isActive = false;
//     };
//   }, [page, pageSize, startDate, endDate, search]);

//   const columns = [
//     {
//       field: "cultivar_name",
//       headerName: "Cultivar Name",
//       flex: 1,
//       minWidth: 160,
//     },
//     { field: "tray_id", headerName: "Tray ID", flex: 1, minWidth: 140 },
//     { field: "cluster_id", headerName: "Cluster ID", flex: 1, minWidth: 140 },
//     {
//       field: "date",
//       headerName: "Date",
//       flex: 1,
//       minWidth: 140,
//       renderCell: (params) => (
//         <div style={{ padding: "10px" }}>
//           {params.row?.date ? dayjs(params.row.date).format("MM-DD-YYYY") : "-"}
//         </div>
//       ),
//     },
//     {
//       field: "before_weight",
//       headerName: "Before Weight",
//       flex: 1,
//       minWidth: 140,
//     },
//     {
//       field: "after_weight",
//       headerName: "After Weight",
//       flex: 1,
//       minWidth: 140,
//     },
//     {
//       field: "rooting_status",
//       headerName: "Rooting Status",
//       flex: 1,
//       minWidth: 160,
//     },
//     {
//       field: "employee_name",
//       headerName: "Employee Name",
//       flex: 1,
//       minWidth: 160,
//     },
//   ];

//   return (
//     <div className="maintenance-view">
//       <div className="page-title">
//         <div className="title-wrap">
//           <h1>History of Rockwool</h1>
//         </div>
//       </div>
//       <Tabs
//         value={tab}
//         onChange={(e, newValue) => setTab(newValue)}
//         sx={{
//           backgroundColor: "#fffffc",
//           "& .MuiTabs-indicator": { backgroundColor: "#00A272", height: "3px" },
//           "& .MuiTab-root": {
//             position: "relative",
//             color: "#A1A2A1",
//             fontWeight: 400,
//             fontSize: "16px",
//             textTransform: "none",
//             padding: "12px 20px",
//             marginRight: "8px",
//             "&:not(.Mui-selected)::after": {
//               content: '""',
//               position: "absolute",
//               left: 0,
//               right: 0,
//               bottom: 0,
//               height: "3px",
//               backgroundColor: "#C4C4C4",
//             },
//             "&.Mui-selected": {
//               color: "#00A272 !important",
//               fontWeight: 600,
//               backgroundColor: "#E6F6F1",
//               borderRadius: "4px 4px 0 0",
//             },
//           },
//         }}
//       >
//         <Tab label="0-7 Days" />
//         <Tab label="8-14 Days" />
//         <Tab label="15-21 Days" />
//       </Tabs>
//       <div className="table-filter-wrap d-flex justify-content-between pb-0 pt-4">
//         <div className="header_search-wrap">
//           <div className="header_search_bar common_content">
//             <div className="input-group input_group">
//               <button className="btn search-btn search_btn">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="15"
//                   height="15"
//                   viewBox="0 0 21 21"
//                   fill="none"
//                 >
//                   <circle
//                     cx="9.98856"
//                     cy="9.98856"
//                     r="8.98856"
//                     stroke="#495057"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                   <path
//                     d="M16.2402 16.7071L19.7643 20.222"
//                     stroke="#495057"
//                     strokeWidth="1.5"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </button>
//               <input
//                 type="search"
//                 className="form-control form_control"
//                 placeholder="Search..."
//                 aria-label="Search"
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//             </div>
//           </div>
//         </div>
//         <Button
//           variant="outlined"
//           color="primary"
//           onClick={() => setOpenDateModal(true)}
//           className="filters-btn"
//           style={{ textTransform: "none" }}
//         >
//           <TbFilterEdit /> Filters
//         </Button>
//       </div>
//       <div>
//         <div
//           style={{
//             height: `${rows?.length > 0 ? "" : "200px"}`,
//             width: "100%",
//             marginTop: 12,
//           }}
//         >
//           <DataGrid
//             rows={rows}
//             getRowId={(r) =>
//               r.id ||
//               r._id ||
//               `${r.tray_id}-${r.cluster_id}-${r.date}-${Math.random()}`
//             }
//             columns={columns}
//             loading={loading}
//             rowCount={rowCount}
//             pageSizeOptions={[15, 50, 100]}
//             paginationModel={{ pageSize, page }}
//             paginationMode="server"
//             onPaginationModelChange={({ page, pageSize }) => {
//               setPage(page);
//               setPageSize(pageSize);
//             }}
//             getRowHeight={() => "auto"}
//             sx={{
//               border: "1px solid #E0E0E0",
//               [`& .${gridClasses.cell}`]: { py: 0.5 },
//             }}
//             autoHeight
//             showCellVerticalBorder
//             showColumnVerticalBorder
//           />
//         </div>
//       </div>
//       {openDateModal && (
//         <DateTimeModal
//           handleDateTimeModal={() => setOpenDateModal(false)}
//           setStartDate={(e) => setStartDate(e)}
//           setEndDate={(e) => setEndDate(e)}
//           open={openDateModal}
//           fetchSchedule={() => {
//             const rockwoolDateFilter = {
//               startDate: startDate,
//               endDate: endDate,
//               selectedRadio: selectedRadio,
//             };
//             localStorage.setItem(
//               "rockwoolDateFilter",
//               JSON.stringify(rockwoolDateFilter)
//             );
//             setPage(0);
//           }}
//           selectedRadio={selectedRadio}
//           setSelectedRadio={(e) => setSelectedRadio(e)}
//           startDate={startDate}
//           endDate={endDate}
//         />
//       )}
//     </div>
//   );
// }

// export default Rockwool;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { Tabs, Tab, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { gridClasses } from "@mui/x-data-grid/constants";
import { HttpService } from "../../../service/HttpService";
import dayjs from "dayjs";
import { TbFilterEdit } from "react-icons/tb";
import DateTimeModal from "../../Schedule/ScheduleListAdd/DateTimeModal";
import { useAuth } from "../../../context/AuthProvider";
import { handleDownloadRockwoolExcel } from "../DownloadRockwool";
import { FaFileExcel } from "react-icons/fa";

function Rockwool() {
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = useMemo(
    () => new HttpService(setShowLoginPopup),
    [setShowLoginPopup]
  );
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [openDateModal, setOpenDateModal] = useState(false);

  const dateFilterData = JSON.parse(localStorage.getItem("rockwoolDateFilter"));
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate || dayjs().endOf("month").format("YYYY-MM-DD")
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio || "month"
  );

  // mapping of tab index → tab_type value from backend
  const tabTypes = ["zerotoseven", "eighttofourteen", "fifteentotwentyone"];

  const fetchRockwoolHistory = async () => {
    setLoading(true);
    try {
      const url =
        `rockwool/rockwool-history` +
        `?page=${page + 1}&pageSize=${pageSize}` +
        `&start_date=${startDate}&end_date=${endDate}` +
        `&search=${search}&tab_type=${tabTypes[tab]}`;
      const res = await httpService.get(url);
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];
      const total = res?.data?.meta?.total || list.length || 0;

      setRows(list);
      setRowCount(total);
    } catch (_) {
      setRows([]);
      setRowCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRockwoolHistory();
  }, [page, pageSize, search, tab, showLoginPopup]);

  const baseColumns = [
    {
      field: "cultivar_name",
      headerName: "Cultivar Name",
      flex: 1,
      minWidth: 190,
      renderCell: (params) => (
        <>
          <div style={{ padding: "10px" }}>{params?.row?.cultivar_name}</div>
        </>
      ),
    },
    { field: "tray_id", headerName: "Tray ID", flex: 1, minWidth: 140 },
    // {
    //   field: "date",
    //   headerName: "Date",
    //   flex: 1,
    //   minWidth: 140,
    //   renderCell: (params) => (
    //     <div style={{ padding: "10px" }}>
    //       {params.row?.date ? dayjs(params.row.date).format("MM-DD-YYYY") : "-"}
    //     </div>
    //   ),
    // },
    {
      field: "before_weight",
      headerName: "Before Weight",
      flex: 1,
      minWidth: 190,
      renderHeader: () => (
        <>
          <div className="MuiDataGrid-columnHeaderTitle">Before Weight</div>
          <div className="ps-1" style={{ fontSize: "12px" }}>
            Grams
          </div>
        </>
      ),
    },
    {
      field: "after_weight",
      headerName: "After Weight",
      flex: 1,
      minWidth: 190,
      renderHeader: () => (
        <>
          <div className="MuiDataGrid-columnHeaderTitle">After Weight</div>
          <div className="ps-1" style={{ fontSize: "12px" }}>
            Grams
          </div>
        </>
      ),
    },
    {
      field: "rooting_status",
      headerName: "Rooting Status",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "employee_name",
      headerName: "Employee Name",
      flex: 1,
      minWidth: 190,
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => (
        <>
          <div style={{ padding: "10px" }}>
            {params.row?.date
              ? dayjs(params.row.date).format("MM-DD-YYYY")
              : "-"}
          </div>
        </>
      ),
    },
  ];

  // Add cluster_id or clone_id depending on tab
  let columns = [...baseColumns];
  if (tabTypes[tab] === "zerotoseven") {
    columns.splice(2, 0, {
      field: "cluster_id",
      headerName: "Cluster ID",
      flex: 1,
      minWidth: 170,
    });
    columns = columns.filter((col) => col.field !== "rooting_status");
  } else {
    columns.splice(2, 0, {
      field: "clone_id",
      headerName: "Clone ID",
      flex: 1,
      minWidth: 140,
    });
    // Remove before/after weight for fifteentotwentyone
    if (tabTypes[tab] === "fifteentotwentyone") {
      columns = columns.filter(
        (col) => col.field !== "before_weight" && col.field !== "after_weight"
      );
    }
  }

  const onDownloadClick = async () => {
    try {
      await handleDownloadRockwoolExcel(setShowLoginPopup);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };

  // filter rows by selected tab_type
  const filteredRows = rows.filter((row) => row.tab_type === tabTypes[tab]);

  return (
    <div className="maintenance-view">
      <div className="page-title">
        <div className="title-wrap">
          <h1>History of Rockwool</h1>
        </div>
      </div>
      <Tabs
        value={tab}
        onChange={(e, newValue) => setTab(newValue)}
        sx={{
          backgroundColor: "#fffffc",
          "& .MuiTabs-indicator": { backgroundColor: "#00A272", height: "3px" },
          "& .MuiTab-root": {
            position: "relative",
            color: "#A1A2A1",
            fontWeight: 400,
            fontSize: "16px",
            textTransform: "none",
            padding: "12px 20px",
            marginRight: "8px",
            "&:not(.Mui-selected)::after": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              height: "3px",
              backgroundColor: "#C4C4C4",
            },
            "&.Mui-selected": {
              color: "#00A272 !important",
              fontWeight: 600,
              backgroundColor: "#E6F6F1",
              borderRadius: "4px 4px 0 0",
            },
          },
        }}
      >
        <Tab label="0-7 Days" />
        <Tab label="8-14 Days" />
        <Tab label="15-21 Days" />
      </Tabs>

      <div className="table-filter-wrap d-flex justify-content-between pb-0 pt-4">
        <div className="header_search-wrap">
          <div className="header_search_bar common_content">
            <div className="input-group input_group">
              <button className="btn search-btn search_btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <circle
                    cx="9.98856"
                    cy="9.98856"
                    r="8.98856"
                    stroke="#495057"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.2402 16.7071L19.7643 20.222"
                    stroke="#495057"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <input
                type="search"
                className="form-control form_control"
                placeholder="Search..."
                aria-label="Search"
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(0);
                }}
              />
            </div>
          </div>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={() => onDownloadClick()}
            startIcon={<FaFileExcel />}
            className="me-3"
          >
            Download
          </Button> */}
        </div>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpenDateModal(true)}
          className="filters-btn"
          style={{ textTransform: "none" }}
        >
          <TbFilterEdit /> Filters
        </Button>
      </div>

      <div>
        <div
          style={{
            height: `${filteredRows?.length > 0 ? "" : "200px"}`,
            width: "100%",
            marginTop: 12,
          }}
        >
          <DataGrid
            rows={filteredRows}
            getRowId={(r) =>
              r.id ||
              r._id ||
              `${r.tray_id}-${r.cluster_id}-${r.date}-${Math.random()}`
            }
            columns={columns}
            loading={loading}
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize, page }}
            paginationMode="server"
            onPaginationModelChange={({ page, pageSize }) => {
              setPage(page);
              setPageSize(pageSize);
            }}
            getRowHeight={() => "auto"}
            sx={{
              border: "1px solid #E0E0E0",
              [`& .${gridClasses.cell}`]: { py: 0.5 },
            }}
            autoHeight
            showCellVerticalBorder
            showColumnVerticalBorder
          />
        </div>
      </div>

      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => setOpenDateModal(false)}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            const rockwoolDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "rockwoolDateFilter",
              JSON.stringify(rockwoolDateFilter)
            );
            setPage(0);
            fetchRockwoolHistory();
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </div>
  );
}

export default Rockwool;
